export default __webpack_public_path__ + "static/media/integrity.b2291d67.png";